import { AUTH_SIGNOUT_URL } from '@ha/auth/common/routes';

import { defineRoute } from '../defineRoute';

export type SignoutRouteParams = {
  // ...
};

export type SignoutRouteParamsString = {
  // ...
};

export const Signout = defineRoute<
  SignoutRouteParams,
  SignoutRouteParamsString
>({
  pathname: AUTH_SIGNOUT_URL,
  options: { isLandlordRoute: false, isPublic: true },
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
